import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

// Define the type for the action mode (Swap, Deposit, Delegate)
export type ActionType = 'Swap' | 'Deposit' | 'Delegate';
export type ModeType = 'Details' | 'List';

// Define the Zustand store interface
interface IHomeStore {
    currentId?: string;
    // Current action (Swap, Deposit, Delegate)
    currentAction?: ActionType;
    // Current mode (Details, List)
    currentMode?: ModeType;
    // Setters for updating the store
    setCurrentId: (currentId?: string) => void;
    setCurrentAction: (action: ActionType) => void;
    setCurrentMode: (mode: ModeType) => void;
}

// Create Zustand store with Immer middleware
export const useHomeStore = create<IHomeStore>()(
    immer((set) => ({
        // Default id
        currentId: undefined,
        // Default action
        currentAction: undefined,
        // Default mode
        currentMode: undefined,
        // Update current id
        setCurrentId: (currentId) =>
            set((store) => {
                store.currentId = currentId;
            }),

        // Update current action (Swap, Deposit, Delegate)
        setCurrentAction: (action) =>
            set((store) => {
                store.currentAction = action;
            }),

        // Update current mode (Chart, Details)
        setCurrentMode: (mode) =>
            set((store) => {
                store.currentMode = mode;
            }),
    }))
);
